export function authBody() {
  return {
    client_id: process.env.REACT_APP_TEAMMETRICS_AUTH_CLIENT_ID,
    client_secret: process.env.REACT_APP_TEAMMETRICS_AUTH_CLIENT_SECRET,
  };
}
